import { parseAsArrayOf, parseAsInteger, parseAsString } from "nuqs";

// Reusable Array parsers
const parseStringArray = parseAsArrayOf(parseAsString).withOptions({
  clearOnDefault: true,
});
const parseIntegerArray = parseAsArrayOf(parseAsInteger).withOptions({
  clearOnDefault: true,
});

// Common
const locationId = parseAsString.withOptions({ clearOnDefault: true });
const search = parseAsString.withOptions({ clearOnDefault: true });
const lat = parseAsString.withOptions({ clearOnDefault: true });
const lng = parseAsString.withOptions({ clearOnDefault: true });
const start = parseAsString.withOptions({ clearOnDefault: true });
const end = parseAsString.withOptions({ clearOnDefault: true });
const date = parseAsString.withOptions({ clearOnDefault: true });

// Travelers
const adults = parseAsInteger.withOptions({ clearOnDefault: true });
const children = parseAsInteger.withOptions({ clearOnDefault: true });
const rooms = parseAsInteger.withOptions({ clearOnDefault: true });

// Rental Extras
const vehicleType = parseAsString.withOptions({ clearOnDefault: true });
const pickupType = parseAsString.withOptions({ clearOnDefault: true });

// Spa & Activity Extras
const durationRange = parseIntegerArray.withOptions({ clearOnDefault: true });

export const hotelParsers = {
  locationId,
  search,
  lat,
  lng,
  start,
  end,
  adults,
  children,
  rooms,

  // Filters
  priceRange: parseIntegerArray,
  propertyType: parseStringArray,
  propertyRating: parseStringArray,
  numberOfBeds: parseStringArray,
  facilities: parseStringArray,
  distance: parseStringArray,
};

export const rentalParsers = {
  locationId,
  search,
  lat,
  lng,
  start,
  end,
  vehicleType,
  pickupType,

  // Filters
  priceRange: parseIntegerArray,
  gear: parseStringArray,
  engine: parseStringArray,
  size: parseStringArray,
  category: parseStringArray,
  mustInclude: parseStringArray,
  rating: parseStringArray,
};

export const spaParsers = {
  locationId,
  search,
  lat,
  lng,
  date,
  start,

  // Filters
  priceRange: parseIntegerArray,
  durationRange,
  serviceType: parseStringArray,
  rating: parseStringArray,
};

export const activityParsers = {
  locationId,
  search,
  lat,
  lng,
  date,
  start,
  priceRange: parseIntegerArray,
  category: parseStringArray,
  departureTimes: parseStringArray,
  language: parseStringArray,
  options: parseStringArray,
  duration: parseStringArray,
  difficulty: parseStringArray,
  includes: parseStringArray,
  rating: parseStringArray,
};

export const DEFAULT_TRAVELERS = {
  adults: 2,
  children: 0,
  rooms: 1,
} as const;
